import React from 'react';

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'checked' | 'onChange'> {
  label?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      label,
      checked,
      onChange,
      disabled,
      className = '',
      id,
      ...inputProps
    },
    ref,
  ) => {
    const checkboxId =
      id ?? (label ? `checkbox-${label.replace(/\s/g, '-').toLowerCase()}` : undefined);

    const input = (
      <input
        ref={ref}
        type="checkbox"
        id={checkboxId}
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
        disabled={disabled}
        className="accent-brand shrink-0"
        {...inputProps}
      />
    );

    const wrapperClasses = [
      'flex items-center gap-2',
      disabled && 'opacity-50 cursor-not-allowed',
      className,
    ]
      .filter(Boolean)
      .join(' ');

    if (label) {
      return (
        <label htmlFor={checkboxId} className={wrapperClasses}>
          {input}
          <span className="text-sm text-content-secondary">{label}</span>
        </label>
      );
    }

    return <div className={wrapperClasses}>{input}</div>;
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
